import WarehousingRateForm from "./WarehouseRates";
export default WarehousingRateForm;
